<template>
  <div class="ActivityInfo">
    <!-- <my_content :content="info.content" :inputStyle="activityStyle"></my_content> -->
    <activity_notification></activity_notification>
  </div>
</template>

<script>
 import MyContent from '@/components/Content.vue';
 import ActivityNotification from '@/components/frontpage/ActivityNotification.vue'
 export default {
   name: 'ActivityInfo',
   props: ['info'],
   computed: {
     activityStyle () {
       return this.$store.state.frontpage.info.activity.style
     },
     organizers () {
       return this.$store.getters.organizers
     },

   },
   components: {
     my_content: MyContent,
     activity_notification: ActivityNotification
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .ActivityInfo {
   width: 100%;
   /* min-height: 48vw; */
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: space-between;
 }
 .organizer{
   width: 85vw;
   display: flex;
   justify-content: space-around;
   align-items: center;
 }

@media (min-width: 320px) and (max-width: 480px) {
 .ActivityInfo {
   height: 70vw;
 }
  .organizer{
    width: 100vw;
  }
 }
</style>
